/**
 * Created by Qingger Corp.
 * User: Thinkpad
 * Date: 2019/6/6
 * Time: 16:28
 * Desc: 虚拟店长管理
 */

import { Component, Vue, Watch } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import NP from 'number-precision';
import { cloneDeep } from 'lodash';
import childList from './childList';
import AdjustmentHistory from './adjustmentHistory';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import { PolicyTypeText } from '@/views/components/newDistribution/newDistributionList';
import { noop, showPlatform } from '@/util';
import ExportFile from '@/views/components/exportFile';

enum StateSotre {
  CANCELLED = -1, // 注销
  DISABLED, // 禁用
  ENABLE, // 启用
  ALL = 9, // 全部
}

@Component({
  components: {
    NoAuth,
    ExportFile,
    AdjustmentHistory,
  },
})
export default class VGuider extends Vue {
  /* 数据 */

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 商品列表
   * @type {Array<ItemObject>}
   */
  public managerList: Array<GuiderList> = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 二级明细页码
   * @type {number}
   */
  public childPage = 1;

  /**
   * 二级明细每页数量
   * @type {number}
   */
  public childPageSize = 10;

  /**
   * 二级明细条数
   * @type {number}
   */
  public childTotalCount = 0;

  /**
   * 二级明细列表
   * @type {Array}
   */
  public childDetailList: Array<ChildGuiderList> = [];

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 是否选中活动
   * @type {boolean}
   */
  public isSelected = false;

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 排序名称
   * @type {string}
   */
  public order = '';

  /**
   * 排序方式
   * @type {string}
   */
  public orderBy = '';

  /**
   *  导出按钮的信息
   * @type {ItemObject}
   */
  public exportBtnInfo: ItemObject = {
    state: 0,
    url: '',
  };

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /**
   * socket连接准备
   * @type {boolean}
   */
  public isSocketReady = false;

  /**
   * 二级明细弹窗可用
   */
  public chidInfoVisible = false;

  /**
   * 二级明细店长手机号
   */
  public vGuiderPhone = -1;

  /**
   * 角色标签
   */
  public tagType: number | string = '';

  /**
   * 角色标签列表
   */
  public tagTypeList: ItemArray = [];

  /**
   * 分销类型
   */
  public distributionType: number | string = '';

  /**
   * 分销类型列表
   */
  public distributionTypeList = PolicyTypeText;

  /**
   * 分销员状态
   */
  public distributorState: string | number = '';

  // 账户余额调整

  public accountBalanceEditShow = false;

  /**
   * 新增分类表单数据
   * @type {ItemObject}
   */
  public addForm: ItemObject = {};

  public changeForm = {
    type: 1,
    balanceChange: 0,
    reason: '',
  };

  changeFormKey = 0;

  // 是否展示

  public isCanChange: boolean | number = false;

  $refs: {
    changeForm: ElForm;
  };

  showPlatform = showPlatform(['really', 'footmark', 'devtest2']);

  /**
   * 数据效验（整数）
   * @type {Function}
   */
  numberRule(rule, value, callback) {
    const reg = /^\d*$/;
    if (value === '') {
      callback(new Error('不能为空'));
    } else if (value === 0) {
      callback(new Error('请输入不为0的数'));
    } else {
      callback();
    }
  }

  public rules = {
    balanceChange: [{ required: true, validator: this.numberRule, trigger: ['blur'] }],
    reason: [{ required: true, message: ' ', trigger: 'blur' }],
  };

  /**
   * 分销员状态列表
   */
  public distributorStateList = [
    { label: '全部', value: StateSotre.ALL },
    { label: '已注销', value: StateSotre.CANCELLED },
    { label: '禁用', value: StateSotre.DISABLED },
    { label: '启用', value: StateSotre.ENABLE },
  ];

  get exportParams() {
    return {
      keywords: this.keywords,
      order: this.order,
      orderBy: this.orderBy,
      policyType: this.distributionType === '' ? 9 : this.distributionType,
      tagName: `${this.tagType}` ? this.tagTypeList[this.tagType] || '' : '',
      state: this.distributorState === '' ? 9 : this.distributorState,
    };
  }

  get windowShow() {
    return this.accountBalanceEditShow && this.showPlatform;
  }

  /**
   * 分销类型切换
   */
  public distributionTypeChange() {
    this.page = 1;
    this.onGetManagerList();
  }

  /**
   * 角色标签切换
   */
  public tagTypeChange() {
    this.page = 1;
    this.onGetManagerList();
  }

  /**
   * 切换状态
   */
  public distributorStateChange() {
    this.page = 1;
    this.onGetManagerList();
  }

  /**
   * 关键字搜索
   */
  public onSearch() {
    this.page = 1;
    this.onGetManagerList();
  }

  /**
   * 获取角色标签列表
   * @return null
   */
  public getTagList() {
    IPSService.guiderTagList({
      postParams: {
        siteCode: [],
      },
    }).then((response) => {
      this.tagTypeList = response.list;
    });
  }

  /**
   * 获取分销商品列表
   * @return null
   */
  public onSearchVGuiderList(): void {
    this.page = 1;
    this.pageSize = 10;
    this.onGetManagerList();
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.onGetManagerList();
  }

  /**
   * 页码变更
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.onGetManagerList();
  }

  /**
   * 选中的活动
   * @param val
   * @return null
   */
  public onHandleSelectionChange(val): void {
    this.isSelected = val.length > 0;
  }

  /**
   * 去往虚拟店长信息页面
   * @param {number} id
   * @param {string} name
   * @return null
   */
  public onGoToVGuiderInfo(vGuiderId: string, id: number, name): void {
    this.$router.push({ path: `vGuiderReport/manager/${id}/2`, query: { vGuiderId } });
    this.$store.commit('onModifyGuiderName', name);
  }

  /**
   * 获取虚拟店长列表
   * @return null
   */
  public onGetManagerList(): void {
    this.managerList = [];
    const postParams = {
      page: this.page,
      pageSize: this.pageSize,
      keywords: this.keywords,
      order: this.order,
      orderBy: this.orderBy,
      policyType: this.distributionType === '' ? 9 : this.distributionType,
      tagName: this.tagTypeList[this.tagType] || '',
      state: this.distributorState === '' ? 9 : this.distributorState,
    };

    IPSService.reportVGuiderList({ postParams }).then((res: ItemObject) => {
      // 格式化数据
      if (res.list.length > 0) {
        res.list.forEach((item) => {
          item.deposit = Number(item.deposit ? item.deposit.toFixed(2) : 0);
          item.orderGoodsNum = Number(item.orderGoodsNum || 0);
          item.orderPrice = Number(item.orderPrice ? item.orderPrice.toFixed(2) : 0);
          item.profit = Number(item.profit ? item.profit.toFixed(2) : 0);
          item.accountBalance = Number(item.accountBalance ? item.accountBalance.toFixed(2) : 0);
          item.profitIng = Number(item.profitIng ? item.profitIng.toFixed(2) : 0);
          item.profitOutTotal = Number(item.profitOutTotal ? item.profitOutTotal.toFixed(2) : 0);
          item.addTime = Functions.emptyVaribleHandler(item.addTime);
          item.tagName = Functions.emptyVaribleHandler(item.tagName);
        });
      }
      this.managerList = res.list;
      this.totalCount = res.count;
    });
  }

  /**
   * 虚拟店长列表排序
   * @param {ItemObject} column
   * @return null
   */
  public onSortChange(column: ItemObject): void {
    this.order = column.prop;
    this.orderBy = column.order === 'ascending' ? 'ASC' : 'DESC';
    this.onGetManagerList();
  }

  /**
   * 鼠标移入
   * @param {ItemObject} item
   * @return null
   */
  public onHoverIn(item: ItemObject): void {
    if (this.showPlatform) {
      this.$set(item, 'isHovered', true);
    }
  }

  /**
   * 鼠标移出
   * @param {ItemObject} item
   * @return null
   */
  public onHoverOut(item: ItemObject): void {
    if (this.showPlatform) {
      this.$set(item, 'isHovered', false);
    }
  }

  public onEditAccountBalance(item: ItemObject): void {
    this.accountBalanceEditShow = true;
    this.changeFormKey = Math.random();
    this.addForm = item;
    this.changeForm = { type: 1, balanceChange: 0, reason: '' };
    IPSService.vGuiderChangeBalanceCheck({ postParams: { vGuiderId: item.vGuiderId } })
      .then((res) => {
        if (res) {
          this.isCanChange = res.isCanChange; // 0不能修改（提现申请未处理完毕） 1可以修改
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  changeBalance() {
    Functions.limitClick(1000).then(async (res) => {
      (this.$refs.changeForm as ElForm).validate((valid) => {
        if (valid) {
          const postParams = {
            vGuiderId: this.addForm.vGuiderId,
            type: this.changeForm.type,
            balanceChange: NP.times(this.changeForm.balanceChange, 100),
            reason: this.changeForm.reason,
            originBalance: this.addForm.accountBalance,
          };

          IPSService.vGuiderChangeBalance({ postParams })
            .then((res) => {
              if (res.errorCode === 0) {
                this.$message.success('修改成功');
                this.accountBalanceEditShow = false;
                this.onGetManagerList();

              } else if (res.errorCode === 10013) {
                this.$message.warning('由于账户余额发生变更,调整失败!请重新操作');
                this.addForm.accountBalance = res.balance / 100;
              } else if (res.errorCode === 10014) {
                this.$message.warning('当前账户尚有提现申请未处理完毕，不可进行余额调整！');
                this.isCanChange = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    });
  }

  moneyRevert(money) {
    return (
      `￥${Number(money)
        .toString()
        .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
    );
  }

  computeMoney() {
    return this.changeForm.balanceChange ? (this.changeForm.type === 2 ? NP.minus(this.addForm.accountBalance, this.changeForm.balanceChange) : NP.plus(this.addForm.accountBalance, this.changeForm.balanceChange)) : this.addForm.accountBalance;
  }

  checkNumber(value) {
    let temp = value.toString();
    temp = temp.replace(/[^\d.]/g, '');
    temp = temp.replace(/^\./g, '');
    temp = temp.replace(/\.{2,}/g, '');
    temp = temp.replace('.', '$#$').replaceAll('.', '').replace('$#$', '.');
    temp = temp.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
    return +temp;
  }

  changeNumber() {
    this.changeForm.balanceChange = this.checkNumber(this.changeForm.balanceChange);
  }

  // 调整履历
  openHistory(card) {
    const value = card ? card : '';
    AdjustmentHistory.open({ keyword: value })
      .then()
      .catch((err) => {
        console.log(err);
      });
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-REPORT-V-GUIDER');
    if (this.isContentBodyShow) {
      this.onGetManagerList(); // 获取虚拟店长列表
      this.getTagList();
      this.changeForm.type = 1;
    }
  }

  /**
   * 二级明细
   * @return boolean
   */
  public getChildDetail(vGuiderId: number) {
    childList.open({ vGuiderId }).then(noop, noop);
  }

  /**
   * 二级明细变更显示条数
   */
  onChildSizeChange(val: number) {
    this.childPageSize = val;
    this.getChildDetail(this.vGuiderPhone);
  }

  /**
   * 二级明细变更页码
   */
  onChildPageChange(val: number) {
    this.childPage = val;
    this.getChildDetail(this.vGuiderPhone);
  }
}
